import { Injectable } from '@angular/core';
import { UserModel } from 'src/models/user.model';
import { ShareDataService } from '../providers/sharedata.service';
import { CorrectYeKeService } from './correctyeke.service';
import { LocalStoreManager } from './local-store-manager.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private redirectUrl = '/';
  private loginUrl = '/login';
  private ordermanagementUrl = '/ordermanagement';
  private isloggedIn = false;
  public loggedInUser: UserModel;
  public users: UserModel[];
  // = [
  //     {username: 'admin' , password : 'Sepidz@123'},
  //     {username: 'user', password : '123'}];
  constructor(private storage: LocalStoreManager) {

  }
  isUserAuthenticated(username: string, password: string): boolean {
    let user: any;
    user = this.users.filter(
      u => CorrectYeKeService.getCorrectYeKe(u.name) === CorrectYeKeService.getCorrectYeKe(username) &&
        CorrectYeKeService.getCorrectYeKe(u.password) === CorrectYeKeService.getCorrectYeKe(password)
    );
    if (user.length !== 0) {
      this.isloggedIn = true;
      this.loggedInUser = user[0];
      //this.loggedInUser.loginDate = new Date();
      //this.storage.savePermanentData(this.loggedInUser, 'user');
    } else {
      this.isloggedIn = false;
    }
    return this.isloggedIn;
  }
  isUserLoggedIn(): boolean {
    return this.isloggedIn;
  }
  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }
  getLoginUrl(): string {
    return this.loginUrl;
  }
  getLoggedInUser(): UserModel {
    return this.loggedInUser;
  }
  getOrdermanagementUrl(): string {
    return this.ordermanagementUrl;
  }
  logoutUser(): void {
    this.isloggedIn = false;
  }
  getDiffDays(sDate, eDate) {
    var startDate = new Date(sDate);
    var endDate = new Date(eDate);
    var Time = endDate.getTime() - startDate.getTime();
    return Time / (1000 * 3600 * 24);
  }
}
